import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from 'app/models/messages';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { startWith, map } from 'rxjs/operators';
import { FormGroup, FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-list-inversores',
  templateUrl: './list-inversores.component.html',
  styleUrls: ['./list-inversores.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class ListInversoresComponent implements OnInit {

  user:any;
  form: FormGroup;
  id: string = "";
  ruc = new FormControl();
  Fruc  = new FormControl();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  
  pageSizeOptions = [10,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean=false;
  displayedColumns: string[] = ['Acciones','Num_Doc_Identificacion','Razon_Social','Canal','Alta_Fecha','Estado'];
  dataSource = new MatTableDataSource( this.docNegociables) ;

  filteredInversionistas: Observable<any[]>;
  filteredInversionistas2: Observable<any[]>;
  
  InversionistasArr;
  InversionistasArr2;

  constructor(
    private empresasService:EmpresasService, 
    private riesgoService:RiesgoService, 
    private router :Router, 
    private loginService:LoginService,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus){
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
  }

  ngOnInit() {
    this.ObtenerInversionistasCombo();
    this.ObtenerInversionistasComboRuc();
  }

  ObtenerInversionistasCombo() {
    this.riesgoService.obtenerInversionistasFondoRiesgo().subscribe(
      resp => {
        this.InversionistasArr  = resp;

        this.InversionistasArr.forEach(element => {
          element.Tipo_Doc_Identificacion = element.empresa.Tipo_Doc_Identificacion.toString();
          element.Num_Doc_Identificacion = element.empresa.Num_Doc_Identificacion.toString();
          element.Razon_Social = element.empresa.Razon_Social;
          
        });

      },
      (err: HttpErrorResponse) => {
        this.InversionistasArr = [];
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA INVERSIONISTAS NO OBTENIDO. "+this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.InversionistasArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));   
    this.filteredInversionistas = this.ruc.valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProv(state) : this.InversionistasArr.slice())
    );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.InversionistasArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerInversionistasComboRuc() {
    this.InversionistasArr2 = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredInversionistas2 = this.Fruc.valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProvRuc(state) : this.InversionistasArr2.slice())
    );
  }

  private _filterProvRuc(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.InversionistasArr2.filter(
      state => state.Num_Doc_Identificacion.toLowerCase().indexOf(filterValue) === 0
    );
  }

  filtradoInversionistas(){
    this.loading = true;
    this.empresasService.obtenerListaInversores(this.id).subscribe(  
      resp => { 
        this.docNegociables = resp
        this.dataSource = new MatTableDataSource(this.docNegociables);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15,20,30,50,100,200];
        this.loading = false;
    }, (err: HttpErrorResponse)=> {
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
       } else {
        this.msgStatus.getMessage(err.status);            
    }
    Swal.fire({
      title: this.msgTitulos.Error,
      text: "LISTA INVERSIONISTAS NO OBTENIDO. "+this.msgStatus.message,
      type: "error",
      allowOutsideClick: false,
      heightAuto: false
    });
    })
  }

  editar(id: string) {
    sessionStorage.setItem('rucEmpresa',id);
    this.loginService.clickGuard = true;
    this.router.navigate(['/empresas/inversor/editar/', id])
  }

  obtenerId(termino: string){
    this.id = termino;
  }

  obtenerRucRazSocial(termino: string = ''){
    
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.InversionistasArr){
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
          this.id = p.Num_Doc_Identificacion;
        }
      }
    }
  }
  contratos(id?: string, razSocial?: string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial', razSocial);
    this.empresasService.tipoServicio = 139
    this.router.navigate(['/empresas/inversor/contratos/', id])
  }
  referenciasBancarias(id : string , razSocial? : string){
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial',razSocial);
    this.empresasService.tipoServicio = 139
    this.router.navigate(['/empresas/inversor/refBancarias/',id])

  }
  contactos(element: any) {
    this.loginService.clickGuard = true;
    this.empresasService.ruc = element.Num_Doc_Identificacion;
    sessionStorage.setItem('razSocial',element.Razon_Social);
    this.router.navigate(['/empresas/inversor/contactos/',element.idEmpresa]);
  }
}
